<template>
    <div class="tour-btn-container broker">
        <shake-animate>
            <template v-slot="shakeStyle">
                <span
                    class="btn-item save"
                    @click="onFavoriteClick"
                    v-if="info.listingStatus != 'Sold'"
                    :class="[
                        hasFavor ? 'active' : '',
                        !hasFavor && shakeStyle.animate
                    ]"
                >
                    <i class="iconfont icon-heart default"></i>
                    <i class="iconfont icon-heart-fill hover"></i>
                    <span class="btn-text">{{
                        $t('md-detail-info.save')
                    }}</span>
                </span>
            </template>
        </shake-animate>
        <!-- tour button  -->
        <span
            v-for="(tour, i) in tourBtnList"
            :key="[tour.text, tour.link].join('_')"
            class="btn-item virtual-tour"
        >
            <a
                href="javascript:;"
                @click="handleTour($event, tour)"
                :style="{
                    '--bg-color': generateColor(0.05, tour),
                    '--hover-bg-color': generateColor(0.15, tour)
                }"
                rel="noopener noreferrer"
            >
                <i
                    class="iconfont"
                    :class="iconList[i]"
                    :style="{ color: colorMap(tour) }"
                ></i>
                <span class="btn-text" :style="{ color: colorMap(tour) }">{{
                    tour.text
                }}</span>
            </a>
        </span>
    </div>
</template>

<script>
import TourBtnMediaMixin from '../../tourBtnMediaPopMixin.js';
import shakeAnimate from '../../shake-animate.vue';

function iconMap(text) {
    const videoReg = /video/gi;
    return videoReg.test(text) ? 'icon-video-block' : 'icon-3d-template4';
}
export default {
    mixins: [TourBtnMediaMixin],
    inject: ['onFavoriteClick'],
    components: { shakeAnimate },
    methods: {
        color2Hex(color) {
            let sColor = color.toLowerCase();
            let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
            if (sColor && reg.test(sColor)) {
                if (sColor.length === 4) {
                    let sColorNew = '#';
                    for (let i = 1; i < 4; i += 1) {
                        sColorNew += sColor
                            .slice(i, i + 1)
                            .concat(sColor.slice(i, i + 1));
                    }
                    sColor = sColorNew;
                }
                let sColorChange = [];
                for (let i = 1; i < 7; i += 2) {
                    sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)));
                }
                return sColorChange.join(',');
            }
            return sColor;
        },
        colorMap(tour) {
            const colors = ['#3b6ef1', '#20c472'];
            const videoReg = /video/gi;
            let isVideo = [tour.link, tour.text].some(v => videoReg.test(v));
            return isVideo ? colors[0] : colors[1];
        },
        generateColor(opacity, tour = {}) {
            if (this.isMobileSize) {
                return 'unset'; 
            }
            return `rgba(${this.color2Hex(this.colorMap(tour))}, ${opacity})`;
        }
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        iconList() {
            return this.tourBtnList.map(v => v.icon || iconMap(v.text))
        }
    }
};
</script>

<style lang="scss">
.tour-btn-container.broker {
    width: 100%;
    display: flex;
    .btn-item {
        width: calc((100% - 40px) / 3);
        margin-right: 20px;
        cursor: pointer;
        color: #33cf81;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 35px;
        &.save {
            background-color: rgba(#f0454c, 0.05);
            color: #f0454c;
            &:hover {
                background-color: rgba(#f0454c, 0.15);
            }
            .btn-text {
                color: #f0454c;
            }
            .hover {
                display: none;
            }
            .iconfont {
                margin-right: 10px;
            }
            &.active {
                .default {
                    display: none;
                }
                .hover {
                    display: block;
                }
            }
        }
        .iconfont {
            font-size: 20px;
            display: block;
            line-height: 30px;
        }
        .btn-text {
            font-size: 14px;
            color: var(--color-disable);
        }
        &:last-child {
            margin-right: 0;
        }
        & > a {
            width: 100%;
            cursor: pointer;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 35px;
            background-color: var(--bg-color);
            &:hover {
                background-color: var(--hover-bg-color);
            }
            .iconfont {
                margin-right: 10px;
            }
        }
    }
}
@media (max-width: 600px) {
    .tour-btn-container.broker {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .btn-item {
            width: 40px;
            height: 100%;
            text-align: center;
            cursor: pointer;
            margin-right: 10px;
            color: #33cf81;
            text-align: center;
            &.save {
                color: #f0454c;
            }
            .iconfont {
                font-size: 18px;
                display: block;
                line-height: 30px;
            }
            .btn-text {
                font-size: 12px;
                color: var(--color-disable);
            }
            a {
                flex-direction: column;
                border-radius: 0;
                border: none;
                .iconfont {
                    font-size: 20px;
                    margin-right: 0;
                    margin-bottom: 2px;
                }
            }
        }
    }
}
</style>
